import ModalTypes from 'aria-viewer/modal/constants/ModalTypes'
import ModalContentTypes from 'aria-viewer/modal/constants/ModalContentTypes'
import { openModal } from 'aria-viewer/modal/modalActions'
import MobileDetect from 'aria-viewer/utils/mobileDetect'
import RegistrationPageContexts from './RegistrationPageContexts'
import {
    setTourLoadingStatus,
    setTourTitle,
    setExperienceUpdated,
    setTourFontFace,
    setIsExperienceOffline,
} from 'aria-viewer/tour/tourActions'
import axios from 'axios'
import { setAnalyticAttributes, registrationExternalLinkClicked } from 'aria-viewer/analytics/analyticActions'
import { getEnv } from 'aria-viewer/utils/environment'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { isFullScreenActive } from 'aria-viewer/utils/fullScreen'
import TOUR_TYPES from 'aria-viewer/tour/constants/TourTypes'

export const SET_REGISTRATION_PAGE_CONTEXT = 'Registration.SET_REGISTRATION_PAGE_CONTEXT'
export const SET_REGISTRATION_ATTRIBUTES = 'Registration.SET_REGISTRATION_ATTRIBUTES'
export const SET_REGISTRATION_FORMTYPE = 'Registration.SET_REGISTRATION_FORMTYPE'
export const SUBMIT_BUTTON_CLICKED = 'Registration.SUBMIT_BUTTON_CLICKED'

export const setRegistrationAttributes = attributes => ({
    type: SET_REGISTRATION_ATTRIBUTES,
    attributes,
})
export const setRegistrationFormType = formType => ({
    type: SET_REGISTRATION_FORMTYPE,
    formType,
})

export const fetchRegistrationAttributes = (inst_id, loc_id) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        const BASE_URL = getEnv('REACT_APP_BASE_URL')

        axios
            .get(
                `${BASE_URL}/getAnalyticsAndRegistrationAttributes/${inst_id}` +
                    (loc_id ? `/${loc_id}` : '') +
                    `${window.location.search}`
            )
            .then(d => {
                const { data, error } = d
                if (error) {
                    reject(`Retrieving analytics failed: ${error}`)
                } else {
                    resolve({
                        analyticsData: data,
                    })
                }
            })
            .catch(error => {
                if (error.response.status == 404) {
                    // Handle 404
                    const isOfflineExperience = error.response.data.includes('<title>Experience Offline!</title>')

                    if (isOfflineExperience) {
                        //handle offline experience
                        dispatch(setIsExperienceOffline(true))
                    } else {
                        //handle 404
                        //TODO: this needs to use a defined base url
                        window.location = `https://youvisit.com/404-2?redirectedURL=${window.location.pathname}`
                    }
                }
            })
    }).then(val => {
        const {
            analyticsData: {
                analytics,
                experience_updated,
                registration,
                pageTitle,
                font: { hasCustomFonts, customFonts },
            },
        } = val

        dispatch(setTourTitle(pageTitle))
        dispatch(setAnalyticAttributes(analytics))
        dispatch(setRegistrationAttributes(registration))
        dispatch(setExperienceUpdated(experience_updated))
        dispatch(setTourFontFace(hasCustomFonts ? customFonts : false))

        return val
    })
}

export const openWelcomeRegistrationModal = () => {
    return openModal(ModalTypes.ALERT, {
        type: ModalContentTypes.WELCOME_REGISTRATION,
        hasIndependentContainer: true,
    })
}

export const openExternalRegistrationModal = (getState, isIWC) => {
    const state = getState()
    const { tour, location, originalPlatform, platform } = mapSelectorsToProps([
        'tour',
        'location',
        'originalPlatform',
        'platform',
    ])()(state)
    const userkey = state.getIn(['analytics', 'userkey'])
    const sessionId = state.getIn(['analytics', 'sessionId'])

    // post message to window so smart script opens cif in modal //
    const cifData = JSON.stringify({
        data_inst: location.owner_id,
        data_loc: location.loc_id,
        data_userkey: userkey,
        data_sessionid: sessionId,
        data_source: platform,
        data_originalsource: originalPlatform,
        data_tourid: tour.tourid,
        data_hover_width: '80%',
        data_hover_height: '80%',
        data_module: 'cif',
        // data url params are just plain decode & copy to target
        data_url_params: encodeURIComponent(
            'embed_type=' + (isIWC ? TOUR_TYPES.TOUR_TYPE_IWC : TOUR_TYPES.TOUR_TYPE_VIRTUAL_TOUR)
        ),
    })
    parent.postMessage(`data:::launch_modal:::` + `${cifData}`, '*')
}

export const openRegistrationModal = (initBy = ModalTypes.WELCOME_PROMPT, prompt = false) => (dispatch, getState) => {
    const isIWC = getState().getIn(['device', 'useResponsiveUI'])
    if (isIWC && !isFullScreenActive()) {
        openExternalRegistrationModal(getState, isIWC)
    } else {
        /**
         * Registration Modal can either me opened in Parent window or as achild
         */
        dispatch(
            openModal(ModalTypes.ALERT, {
                type: ModalContentTypes.REGISTRATION,
                hasIndependentContainer: true,
                prompt: prompt,
                initBy: initBy,
            })
        )
    }
}

export const onRegistrationPolicyLinkClicked = (eventName, e) => (dispatch, getState) => {
    dispatch(registrationExternalLinkClicked({ eventName }))
}

export const registrationLoaded = () => (dispatch, getState) => {
    const tourLoadingState = getState().getIn(['tour', 'loading', 'tour'])

    if (tourLoadingState) dispatch(setTourLoadingStatus(false))
}

export const setRegistrationPageContext = registrationPageContext => {
    //HACK for bug
    // If we are requesting desktop, but we are in mobile, force mobile
    if (registrationPageContext == RegistrationPageContexts.DESKTOP_LANDING && MobileDetect.mobile()) {
        console.warn(
            'setRegistrationPageContext recieved desktop DESKTOP_LANDING, which is incorrect, since we are on mobile'
        )
        registrationPageContext = RegistrationPageContexts.MOBILE_LANDING
    }
    //HACK for bug
    // If we are requesting desktop, but we are in mobile, force mobile
    if (registrationPageContext == RegistrationPageContexts.MOBILE_LANDING && !MobileDetect.mobile()) {
        console.warn(
            'setRegistrationPageContext recieved desktop MOBILE_LANDING, which is incorrect, since we are on desktop'
        )
        registrationPageContext = RegistrationPageContexts.DESKTOP_LANDING
    }

    return {
        type: SET_REGISTRATION_PAGE_CONTEXT,
        registrationPageContext,
    }
}

export const submitButtonClick = _ => ({
    type: SUBMIT_BUTTON_CLICKED,
})
